<template>
  <div class="car-details" v-loading="oLoading.detail">
    <QS-scroller-box :stepsOpt="stepsOpt">
      <QS-h3-title>
        <template slot="title">
          <el-button
            v-if="
              carMessage == 2 &&
                carState !== 5 &&
                carInfo.exitOperationState !== 1 &&
                judgePermission('updateAndSubmit')
            "
            @click="getcarAuditRecord"
            type="primary"
            size="mini"
            >车辆信息提交审核</el-button
          >
          <el-button
            v-if="
              (carMessage == 1 || carMessage == 2 || carMessage == 4) &&
                carInfo.exitOperationState !== 1 &&
                judgePermission('vehicle_list_edit')
            "
            @click="goEdit('vehicle_list_edit')"
            type="primary"
            size="mini"
            >编辑车辆信息</el-button
          >
        </template>
        <div class="splitline" />
      </QS-h3-title>
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item title="车辆基本信息" name="car_base_info">
          <div class="scroll-box-item">
            <column-box
              :source="carInfo"
              :list="carInfokeyList"
              :labelWidth="130"
            >
            </column-box>
          </div>
          <div class="img-item" v-if="imageData.carDisposePhoto.length > 0">
            <div class="label">处置图片:</div>
            <div class="content" v-if="imageData.carDisposePhoto.length">
              <div
                class="item"
                v-for="(item, index) in imageData.carDisposePhoto"
                :key="index"
              >
                <EnlargeImg :imgSrc="item[0].url" />
              </div>
            </div>
            <div v-else>--</div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="车辆标签" name="car_tag">
          <div class="scroll-box-item">
            <ShowTag :tagList="tagList" labelName="普通标签" />
            <ShowTag :tagList="nonRentableTagList" labelName="不可租赁标签" />
          </div>
        </el-collapse-item>
        <el-collapse-item title="首次入库车况验收" name="car_condition">
          <div class="scroll-box-item">
            <column-box
              :source="carInfo"
              :list="carConditionList"
              :labelWidth="130"
            >
            </column-box>
          </div>
        </el-collapse-item>
        <el-collapse-item title="车辆图片" name="car_photo">
          <div class="scroll-box-item">
            <div class="img-item">
              <div class="label">车辆照片:</div>
              <div class="content" v-if="imageData.carPhoto.length">
                <div
                  class="item"
                  v-for="(item, index) in imageData.carPhoto"
                  :key="index"
                >
                  <EnlargeImg :imgSrc="item" />
                </div>
              </div>
              <div v-else>--</div>
            </div>
            <div class="img-item">
              <div class="label">自定义照片:</div>
              <div class="content" v-if="imageData.carPhotoCustom.length">
                <div
                  class="item"
                  v-for="(item, index) in imageData.carPhotoCustom"
                  :key="index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <el-tooltip
                    effect="dark"
                    :content="item.title"
                    placement="bottom"
                  >
                    <p>自定义</p>
                  </el-tooltip>
                </div>
              </div>
              <div v-else>--</div>
            </div>
          </div>
        </el-collapse-item>
        <el-collapse-item title="备注" name="car_remark">
          <div class="scroll-box-item">
            <div class="remark-item">
              <column-box
                :source="carInfo"
                :list="[{ key: 'remarks', name: '车辆备注' }]"
                :labelWidth="130"
              >
              </column-box>
            </div>
            <div class="img-item">
              <div class="label">备注照片:</div>
              <div class="content" v-if="imageData.remark_imgs.length">
                <div
                  class="item"
                  v-for="(item, index) in imageData.remark_imgs"
                  :key="index"
                >
                  <EnlargeImg :imgSrc="item" />
                  <p>备注照片</p>
                </div>
              </div>
              <div v-else>--</div>
            </div>
          </div>
        </el-collapse-item>
      </el-collapse>
    </QS-scroller-box>
  </div>
</template>
<script>
import CARDICT from '@/store/dict/carDict.js'
import {
  getCarDetails,
  getCityList,
  getcarAuditRecord,
} from '@/api/domain/cars'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import ShowTag from '@/components/ShowTag'

export default {
  name: 'CarInfo',
  components: {
    ShowTag,
  },
  data() {
    return {
      tagList: [], // 选中的普通标签列表（用户选中，传给服务用）
      nonRentableTagList: [], // 选中的不可租标签列表（用户选中，传给服务用）
      oLoading: {
        detail: false,
      },
      carId: '',
      stepsOpt: {
        anchorName: '.demo-section',
      },
      imageData: {
        carPhoto: [],
        carPhotoCustom: [],
        remark_imgs: [],
        carDisposePhoto: [],
      },
      cityList: [], // 注册地
      carTubeList: [], // 车管
      carMessage: '',
      carState: '', // 车辆状态
      carInfokeyList: [
        { key: 'color', name: '车身颜色' },
        { key: 'managerName', name: '所属车管' },
        { key: 'registPlaceName', name: '车辆注册地' },
        { key: 'registDate', name: '注册日期' },
        { key: 'purchaseType', name: '采购类型' },
        { key: 'providerName', name: '车源方' },
        { key: 'gmtCreate', name: '车辆创建时间' },
        { key: 'propertyName', name: '产权方' },
        { key: 'energyTypeDesc', name: '能源类型' },
        { key: 'coolingModeDesc', name: '电池冷却类型' },
        { key: 'displayMile', name: '表显里程', unit: '公里' },
        { key: 'storagePlace', name: '存放地' },
        { key: 'city', name: '运营城市' },
        { key: 'disposalUserName', name: '处置人' },
        { key: 'disposalTime', name: '处置时间' },
        { key: 'disposalMethod', name: '处置方式' },
        { key: 'disposaRemarks', name: '处置原因' },
        { key: 'mortgagor', name: '车辆抵押方' },
        { key: 'deptName', name: '所属部门' },
      ],
      carConditionList: [
        { key: 'appearanceState', name: '车辆外观状态' },
        { key: 'chassisState', name: '车辆底盘状态' },
      ],
      carInfo: {},
      carLicenseInfo: {},
      carTransportLicense: {},
      carRegisterLicense: {},
      // 当前展开面板
      activeNames: [
        'car_base_info',
        'car_tag',
        'car_condition',
        'car_photo',
        'car_remark',
      ],
    }
  },
  props: {
    id: {
      type: [String, Number],
      default: 0,
    },
  },
  async mounted() {
    const { id } = this
    if (id) {
      this.carId = id
    }
    // 车管
    await this.getCarTubeList()

    this.getCarDetails()
    // 注册地
    this.getCityList()
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    handleChange() {},
    // 注册地
    async getCityList() {
      const { code, data } = await getCityList()
      if (code === 1) {
        this.cityList = data
        if (this.carInfo.registPlace) {
          this.carInfo.registPlaceName = this.getCityName(
            this.carInfo.registPlace,
          )
        }
      } else {
        this.$message.error('获取城市列表失败')
      }
    },

    // 车管
    async getCarTubeList() {
      try {
        const { code, data } = await getAllEmployeeList()
        if (code === 1) {
          this.carTubeList = data
        } else {
          this.$message.error('获取车管失败')
        }
      } catch (error) {
        this.$message.error('获取车管失败')
      }
    },

    // 编辑车辆
    goEdit(routeName) {
      this.$router.push({
        name: routeName,
        query: {
          id: this.carId,
        },
      })
    },
    // 获取车辆详情
    async getCarDetails() {
      this.oLoading.detail = true
      const { code, data } = await getCarDetails({
        id: this.carId,
      })
      this.oLoading.detail = false
      if (code === 1 && data) {
        // 车辆基本信息
        this.carInfo = Object.assign({}, data.carInfo)

        // 解析车辆备注
        if (
          data.carInfo &&
          data.carInfo.carRemarks &&
          data.carInfo.carRemarks.length > 0
        ) {
          const [remarkItem] = data.carInfo.carRemarks
          this.carInfo.remarks = remarkItem.remarks
          // 车辆备注图片解析
          remarkItem.photo &&
            (this.imageData.remark_imgs = this.getEchoUploadFileData(
              remarkItem.photo,
            ))
        }

        // 车辆普通标签
        if (data.tagList) {
          this.tagList = data.tagList
        }

        // 车辆不可租标签
        if (data.nonRentableTagList) {
          this.nonRentableTagList = data.nonRentableTagList
        }

        // 行驶证信息
        this.carLicenseInfo = data.carLicenseInfo
        if (
          data.carTransportLicense &&
          data.carTransportLicense.expiryDate
        ) {
          data.carTransportLicense.expiryDate =
            data.carTransportLicense.expiryDate === '2099-09-09'
              ? '长期有效'
              : data.carTransportLicense.expiryDate
        }
        this.carTransportLicense = data.carTransportLicense
          ? data.carTransportLicense
          : {}
        this.carRegisterLicense = data.carRegistCertInfo
          ? data.carRegistCertInfo
          : {}

        // 注册地
        if (this.cityList.length) {
          this.carInfo.registPlaceName = this.getCityName(
            data.carInfo.registPlace,
          )
        }

        // 车管
        if (this.carTubeList.length) {
          this.carInfo.managerName = this.getCarManagerName(
            data.carInfo.managerId,
          )
        }

        // 车源方
        this.carInfo.providerName = data.carInfoModel.providerName || ''

        // 车辆处置信息
        if (data.carDisposal) {
          const {
            disposalUserName,
            disposalTime,
            disposalMethod,
            remarks,
          } = data.carDisposal
          this.carInfo = {
            ...this.carInfo,
            disposalUserName,
            disposalTime,
            disposalMethod: CARDICT.CAR_DISPOSE_METHOD()[disposalMethod],
            disposaRemarks: remarks,
          }
        }

        // 通过字典转换汉字
        this.carInfo.color = CARDICT.CAR_COLOR_DICT()[this.carInfo.color]

        // 车型信息
        this.carInfo.type = CARDICT.CAR_TYPE_DICT()[this.carInfo.type]

        // 车辆外观状态
        this.carInfo.appearanceState = CARDICT.CAR_APPEARANCE_DICT()[
          this.carInfo.appearanceState
        ]

        // 车辆底盘状态
        this.carInfo.chassisState = CARDICT.CAR_CHASSIS_DICT()[
          this.carInfo.chassisState
        ]

        // 采购方式
        this.carInfo.purchaseType = CARDICT.CAR_PROCUREMENT_DICT()[
          this.carInfo.purchaseType
        ]

        // 电池冷却类型
        this.carInfo.coolingMode = CARDICT.VEHICLE_COOLING_MODE()[
          this.carInfo.coolingMode
        ]

        // 能源类型
        this.carInfo.energyType = data.carInfo.energyType
          ? CARDICT.ENERGY_TYPE_LIST()[data.carInfo.energyType]
          : ''

        // 车辆基本状态信息
        this.carInfo.basicItemState = CARDICT.CAR_MESSAGE()[
          data.carInfo.basicItemState
        ]
        this.carMessage = Number(data.carInfo.basicItemState)

        // 车辆状态
        this.carState = Number(data.carInfo.carState)

        // 汽车10照片
        this.imageData.carPhoto = this.getEchoUploadFileData(data.carInfo.photo)
        // 自定义照片
        this.imageData.carPhotoCustom = this.getEchoUploadFileData(
          data.carInfo.customPhoto,
        )
        // 运营城市
        this.carInfo.city = data.carLicenseInfo.city
      }
    },
    async getcarAuditRecord() {
      /// 获取审核状态
      const { data } = await getcarAuditRecord({
        carId: this.carId,
        type: this.carInfo.basicItemState,
      })
      if (data) {
        this.$message.success('信息提交完成，请前往车辆审核模块进行审核')
        this.getCarDetails()
      }
    },
    getCityName(code) {
      const arr = this.cityList.filter((item) => item.adcode === String(code))
      if (arr.length) {
        return arr[0].city
      } else {
        return ''
      }
    },

    getCarManagerName(id) {
      const arr = this.carTubeList.filter((item) => item.id === id)
      if (arr.length) {
        return arr[0].userName
      } else {
        return ''
      }
    },
  },
}
</script>
<style scoped lang="scss">
.car-details {
  height: 100%;

  ::v-deep .el-collapse {
    margin-top: -30px;
    border-top: none;
  }
  ::v-deep .el-collapse-item__content {
    padding-top: 25px;
  }
  ::v-deep .el-collapse-item__wrap {
    border-bottom: none;
  }
  ::v-deep .el-collapse-item__arrow.is-active {
    transform: rotate(-90deg);
  }
  ::v-deep .el-collapse-item__arrow {
    transform: rotate(90deg);
  }
  .float-right {
    float: right;
  }
  .img-item {
    display: flex;
    margin-bottom: 30px;
    .label {
      padding-right: 12px;
      width: 130px;
      text-align: right;
      box-sizing: border-box;
    }
    .content {
      max-width: 480px;
      display: flex;
      flex-wrap: wrap;
      .item {
        margin-left: 16px;
        width: 80px;
        height: 80px;
        &:nth-child(5n + 1) {
          margin-left: 0;
        }
        &:nth-child(n + 6) {
          margin-top: 30px;
        }
      }
      p {
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #969799;
        line-height: 25px;
        overflow: hidden;
        text-align: center;
      }
    }
  }
}
</style>
